import { Exclude, Expose, Type } from 'class-transformer';
import { SubscriptionDTO } from './subscription.dto';

export enum Status {
  PENDING = 'pending',
  DEACTIVATED = 'deactivated',
  CANCELLED = 'cancelled',
  ACTIVATED = 'activated',
  DECLINED = 'declined',
  MISSING_CARD = 'missing_card'
}

@Exclude()
export class CustomerDTO {
  @Expose()
  id: number;

  @Expose()
  expDate: string;

  @Expose()
  status: Status;

  @Expose()
  name: string;

  @Expose()
  @Type(() => SubscriptionDTO)
  subscription: SubscriptionDTO;

  get declined(): boolean {
    return this.status === Status.DECLINED || (this.subscription && ['incomplete', 'incomplete_expired'].indexOf(this.subscription.status) !== -1);
  }
}
